import { render, staticRenderFns } from "./downloadFile.vue?vue&type=template&id=65767031&scoped=true"
import script from "./downloadFile.vue?vue&type=script&lang=js"
export * from "./downloadFile.vue?vue&type=script&lang=js"
import style0 from "./downloadFile.vue?vue&type=style&index=0&id=65767031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65767031",
  null
  
)

export default component.exports